const AppWrapper = ({
  children
}) => {
  return <>{children}</>;
};
export default AppWrapper;